<template>
  <div id="imchatWin" :class="{'show': isShow,'show1':themeLevelShow||upgradeShow}">
    <div class="imchatWin">
      <div class="wintitle">
        {{selToNickName}}
        <i class="el-icon-close" @click="closeChatWin"></i>
      </div>
      <div class="winconwrap" ref="winconwrap">
        <div class="wincon" ref="wincon">
          <!-- todo  -->
          <!--<div v-if="canGetHis" @click="getLastC2CHistoryMsgs(selToID)">获取历史消息</div> -->
          <template v-for="(con, index) in chatlist">
            <p
              class="msgtime"
              v-if="con.isShowTime"
              :key="'chattime' + index"
            >{{dateFormatTime(con.time)}}</p>
            <!-- 自定义消息 -->
            <div v-if="con.type=='TIMCustomElem'" class="lessonmsg bg" :key="'chatcon' + index">
              <p class="title">{{con.lessonInfo.name}}</p>
              <p
                class="time"
                v-if="!!con.lessonInfo.startTime && !!con.lessonInfo.endTime"
              >{{$t("study.classTime")}}: {{global.getFormatTime(con.lessonInfo.startTime, con.lessonInfo.endTime, 0, 0, 0, 1)}}</p>
            </div>
            <div
              v-if="!con.isMe && con.type!='TIMCustomElem'"
              class="mgsbody bg other"
              :key="'chatcon' + index"
            >
              <span v-html="con.con"></span>
              <div class="face">
                <!-- todo 发送方头像 -->
								<img v-if="selToHeadImg" :src="global.getOssFileUrl(selToHeadImg)" alt />
						
								<img src="../../assets/images/defaultface.png" v-else>
              
              </div>
            </div>
            <div
              v-if="con.isMe && con.type!='TIMCustomElem'"
              class="mgsbody bg me"
              :key="'chatcon' + index"
            >
              <span v-html="con.con"></span>
              <div class="face">
                <img v-if="!!userInfo.logoPath" :src="global.getOssFileUrl(userInfo.logoPath)">
                <img v-else src="../../assets/images/defaultface.png">
              </div>
            </div>
          </template>
          <div class="lessonmsg bg" v-if="showLessonInfo">
            <p class="title">{{lessonInfo.name}}</p>
            <p
              class="time"
              v-if="!!lessonInfo.startTime && !!lessonInfo.endTime"
            >{{$t("study.classTime")}}: {{global.getFormatTime(lessonInfo.startTime, lessonInfo.endTime, 0, 0, 0, 1)}}</p>
            <i class="el-icon-close" @click="closeLessonInfo"></i>
            <span class="sendLessonInfoBtn" @click="sendLessonInfo">Send</span>
          </div>
        </div>
      </div>
      <div class="repeatwrap">
        <div class="tools">
          <!-- <span class="facebtn"></span> -->
          <span class="imgbtn" @click="imagesUplodReady"></span>
          <input type="file" ref="images" accept="image/*">
        </div>
        <textarea id="repeatcon" v-model="textareaCon" @keydown.enter="sendMsg" maxlength="300"></textarea>
        <div class="btns">
          <button @click="sendMsg" :disabled="cantSendMsg || isSend" :class="{'issend': isSend}" v-text="isSend ? 'Sending...' : 'Send'"></button>
        </div>
      </div>
    </div>
		<div class="page-mask"  v-if="themeLevelShow">
			<div class="topContent">
				<div class="sxjContent">
					<img class="themeLevel" src="../oralT/img/themeLevel.png" mode="widthFix" />
					<div class="enterpriseName">{{enterpriseName}}</div>
					<div class="text1">
						<template v-if="langIsEn == 'en'">There is a study report after the study.</template>
						<template v-else>完成全部专题还能得到学习报告哦～</template>
					</div>
				</div>
				<van-icon name="close" size="24" @click="themeLevelShow = false" class="close1" color="#fff"></van-icon>
		
			</div>
		</div>
		
		<div class="page-mask"  v-if="upgradeShow">
			<div class="page-wrap1" >
				<div class="content-block " :class="'swiperBj_'+grade">
					<div class="flex flex-between">
						<div class="grade_Content">
							<div class="jbzt">
								<div class="grade_tip_01">恭喜您</div>
								<div class="grade_tip_02">学习等级提升至LV{{grade}}</div>
							</div>
							<div class="grade_tip_03">(当前等级人数:{{sameGradeUserNum}})</div>
						</div>
						<div>
							<img class="grade" :src="require(`../oralT/img/grade_${grade}.png`)" v-if="grade" />
						</div>
					</div>
					<div class="LG_Equity-t">可获得</div>
					<div class="LG_Equity" v-if="grade">
						<div class="LG_Equity_item" v-if="gradeDescList[grade-1].scholarship">
							<img src="../oralT/img/Equity_icon_02.png" mode="aspectFill" class="LG_Equity_Img"
								lazy-load />
							<div class="LG_content">奖学金: {{gradeDescList[grade-1].scholarship}}</div>
						</div>
						<div class="LG_Equity_item" v-if="gradeDescList[grade-1].soundNum">
							<img src="../oralT/img/Equity_icon_01.png" mode="aspectFill" class="LG_Equity_Img"
								lazy-load />
							<div class="LG_content">录音次数: +{{ gradeDescList[grade-1].soundNum }}</div>
						</div>
						<div class="LG_Equity_item" v-if="gradeDescList[grade-1].diowei">
							<img src="../oralT/img/Equity_icon_03.png" mode="aspectFill" class="LG_Equity_Img"
								lazy-load />
							<div class="LG_content">评分多维度分析</div>
						</div>
					</div>
			
				</div>
				<van-icon name="close" size="24" @click="upgradeShow = false" class="close1" color="#fff"></van-icon>
		
			</div>
		</div>
    <div id="mask"></div>
  </div>
</template>

<script>
export default {
  name: "imchatWin",
  data: function() {
    return {
			upgradeShow: false,
			sameGradeUserNum: 0,
	
			grade: 0,
			gradeDescList: [
				{'gradeName': '1', 'scholarship': 1, 'diowei': 1},
				{'gradeName': '2', 'scholarship': 2},
				{'gradeName': '3', 'scholarship': 4, 'soundNum': 1},
				{'gradeName': '4', 'scholarship': 7 },
				{'gradeName': '5', 'scholarship': 11},
				{'gradeName': '6', 'scholarship': 16, 'soundNum': 1},
				{'gradeName': '7', 'scholarship': 22},
				{'gradeName': '8', 'scholarship': 29},
				{'gradeName': '9', 'scholarship': 37},
				{'gradeName': '10', 'scholarship': 46, 'soundNum': 1},
				{'gradeName': '11', 'scholarship': 56},
				{'gradeName': '12', 'scholarship': 67},
				{'gradeName': '13', 'scholarship': 79},
				{'gradeName': '14', 'scholarship': 92},
				{'gradeName': '15', 'scholarship': 106},
				{'gradeName': "16", 'scholarship': 121},
				{'gradeName': "17", 'scholarship': 137},
			],
			themeLevelShow: false,
			enterpriseName: '',
			selToHeadImg:null,
      userId: localStorage.getItem("userId"),
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      loginInfo: {},
      webimOptions: {
        //	im配置
        isAccessFormalEnv: true, // 是否访问正式环境下的后台接口，True-访问正式(默认)，False-访问测试环境
        isLogOn: true // 否开启控制台打印日志，True-开启(默认)，False-关闭，
      },
      selType: this.webim.SESSION_TYPE.C2C, //session模式 这里只用单聊
      EmotionDataIndexs: {}, //  表情标识字符和索引映射关系对象
      Emotions: {},
      selSess: null, //  对话session
      selToID: "", //	发送对象的id
      selToNickName: "", //  发送对象昵称
      chatlist: [], //  聊天内容
      textareaCon: "", //  发送内容
      faceArr: [], //  表情组
      isShow: false, //  是否打开窗口
      linkState: false, //  连接状态 是否链接
      lastChatTime: 0, //  连接状态 是否链接
      lastChatCon: [], //  最后的对话内容列表
      initUnreadList: [], //  初始化未读信息列表

      canGetHis: false, //  是否可以获取历史消息
      MsgKey: "", // 当前对象的历史消息纪录
      LastMsgTime: 0, //  当前对象历史消息时间

      isSend: false, // 是否正在发送
      showLessonInfo: false, //  判断是否有课程信息显示
      lessonInfo: {}, //  学生的课程信息
      langIsEn: localStorage.getItem('lang'),
    };
  },
  computed: {
    cantSendMsg() {  //  如果没有输入内容 不可发送
      return this.textareaCon.trim().length < 1
    }
  },
  watch: {},
  created() {
    let langIsEn = localStorage.getItem('lang')
    if (!langIsEn) {
      this.langIsEn = 'zh'
    } else {
      this.langIsEn = localStorage.getItem('lang')
    }
    //  监听 显示对话框
    this.$root.Bus.$on("chatWin", v => {
      this.showChatWin(v);
    });
    //  获取最近联系人
    //  点击会话列表 和 受到新消息 最近联系人列表中查无此人来触发
    this.$root.Bus.$on("getLastChatCon", v => {
      this.getLastChatMem();
    });
  },
  beforeDestroy() {
    this.$root.Bus.$off("getLastChatCon");
    this.$root.Bus.$off("chatWin");
    this.closeChatWin();
    if (this.linkState) this.logoutIm();
  },
  mounted() {
    //  监听input选择图片文件
    this.$refs.images.addEventListener(
      "change",
      () => {
        this.uploadImage();
      },
      false
    );
    //  初始化登陆
    this.initloginIm();

    let _this = this;
    window.onbeforeunload = function() {
      if (_this.linkState) _this.logoutIm();
    };
  },
  methods: {

    //  登陆im
    initloginIm() {
      this.userId = localStorage.getItem("userId");
      if (!this.userId) return;
      //	向后台获取凭证
      let imUserId = `${this.WITSBOX_ENV_PARAM.IMAccountPrefix}${this.userId}`;
      this.request
        .post(`${this.WITSBOX_ENV_PARAM.baseUrl}/im/authInfo`, {
          userId: imUserId
        })
        .then(res => {
          if (res.success && res.dataModel) {
            this.loginInfo = {
              sdkAppID: res.dataModel.appId, //用户所属应用id,必填
              identifier: imUserId, //当前用户ID,必须是否字符串类型，必填
              accountType: res.dataModel.accountType, //用户所属应用帐号类型，必填
              userSig: res.dataModel.signature,
              identifierNick: this.userInfo.nickName //当前用户名
            };
            this.loginIm();
          } else {
            //  todo 验证错误
          }
        });
    },
    loginIm() {
      this.webim.login(
        this.loginInfo,
        {
          onConnNotify: this.onConnNotify, //用于监听用户连接状态变化的函数，选填
          jsonpCallback: this.jsonpCallback, //IE9(含)以下浏览器用到的jsonp回调函数,移动端可不填，pc端必填
          onMsgNotify: this.onMsgNotify, //监听新消息(私聊(包括普通消息和全员推送消息)，普通群(非直播聊天室)消息)事件，必填
          onKickedEventCall: this.onKickedEventCall //被其他登录实例踢下线
        },
        this.webimOptions,
        resp => {
          //  todo
          console.log(resp);
          // this.linkState = true;
          //  获取未读
          this.getUnreadMsg();
        },
        err => {
          //  todo
          console.log(err);
        }
      );
    },
    //  退出
    logoutIm() {
      //  todo
      this.webim.logout(() => {}, () => {});
      this.linkState = false;
    },
    //	监听用户连接状态变化
    onConnNotify(resp) {
      let info;
      switch (resp.ErrorCode) {
        case this.webim.CONNECTION_STATUS.ON:
          this.webim.Log.warn("建立连接成功: " + resp.ErrorInfo);
          // todo
          this.linkState = true;
          break;
        case this.webim.CONNECTION_STATUS.OFF:
          info =
            "连接已断开，无法收到新消息，请检查下您的网络是否正常: " +
            resp.ErrorInfo;
          this.linkState = false;

          // todo
          this.webim.Log.warn(info);
          break;
        case this.webim.CONNECTION_STATUS.RECONNECT:
          info = "连接状态恢复正常: " + resp.ErrorInfo;
          this.linkState = true;
          // todo
          this.webim.Log.warn(info);
          break;
        default:
          this.webim.Log.error("未知连接状态: =" + resp.ErrorInfo);
          break;
      }
    },
    //IE9(含)以下浏览器用到的jsonp回调函数,移动端可不填，pc端必填
    jsonpCallback() {
      //设置接口返回的数据
      this.webim.setJsonpLastRspData(rspData);
    },
    //	监听新消息(私聊(包括普通消息和全员推送消息)，普通群(非直播聊天室)消息)事件，必填
    onMsgNotify(newMsgList) {
      //newMsgList 为新消息数组，结构为[Msg]
      let sess;
      let sessMap = this.webim.MsgStore.sessMap(); //  获取该用户会话session
      for (var j in newMsgList) {
        //遍历新消息
        let newMsg = newMsgList[j];
        let ANewImMeg;
        if (!!this.selToID && newMsg.getSession().id() == this.selToID) {
          // 这条消息是当前聊天对象发来的
          //selToID 表示当前正在进行的聊天 id，当聊天类型为私聊时，该值为好友帐号，否则为群号。
          //
          this.selToID = newMsg.getSession().id();
          this.selType = newMsg.getSession().type();
          this.selSess = newMsg.getSession();
          let headUrl; //  用户头像
          if (this.selType == this.webim.SESSION_TYPE.C2C) {
            //此处只考虑C2C消息
            //  向窗口新增一条信息
            //消息已读上报，以及设置会话自动已读标记
            this.webim.setAutoRead(this.selSess, true, true);
          }
          this.showMes(newMsg);
          ANewImMeg = {
            id: this.selToID,
            isCur: true,  //  当前对话人员
            msg: newMsg
          };
        } else {
          //  todo不是当前对象发送的信息
          console.log("找不到人", newMsg);
          //  通知闪烁
          //  给消息列表 发送未读 如果没有人就加人
          let sess = newMsg.getSession();
          ANewImMeg = {
            id: sess.id(),
            isCur: false,  //  不是当前对话人员
            msg: newMsg
          };
          if(ANewImMeg.id=="deadmin") {
            this.getCustomMessage(ANewImMeg.msg) ;
          } else {
            this.$root.Bus.$emit("newImMeg", true);
            //  给本地未读列表增加一条信息
            this.addUnreadListCount(sess.id());
          }
         
        }
        if(ANewImMeg.id=="deadmin") {
          // 奖学金IM消息什么都不做 到移动端处理
        } else {
          this.$root.Bus.$emit("ANewImMeg", ANewImMeg);
        }
        //  todo桌面通知
      }
    },
    //	被其他登录实例踢下线
    onKickedEventCall() {
      //  todo
      // alert("被T");
      this.logoutIm();
    },
    //  上传进度条
    onProgressCallBack(loadedSize, totalSize) {},
    //  发送消息
    sendMsg() {
      if (this.isSend) return;
      this.textareaCon = this.textareaCon.trim();
      if (!this.textareaCon || !this.selToID) return;
      let msgContent = this.textareaCon;
      let msgLen = this.webim.Tool.getStrBytes(msgContent); //获取字符串（UTF-8 编码）所占字节数

      let maxLen = this.webim.MSG_MAX_LENGTH.C2C,
        errInfo = "消息长度超出限制(最多" + Math.round(maxLen / 3) + "汉字)";
      if (msgLen > maxLen) {
        console.log(errInfo);
        return;
      }

      if (!this.selSess) {
        this.selSess = new this.webim.Session(
          this.selType, //会话类型， 包括群聊和私聊，具体参考 webim. SESSION_TYPE 常量对象，必填
          this.selToID, //对方 ID，群聊时，为群ID；私聊时，对方帐号，必填
          "", //对方名称，群聊时，为群名称；私聊时，为对方昵称，暂未使用，选填
          "", //对方头像 URL，暂未使用，选填
          Math.round(new Date().getTime() / 1000) //当前会话中的最新消息的时间戳，UNIX timestamp 格式，暂未使用，选填
        );
      }

      let seq = -1; //消息序列，-1表示sdk自动生成，用于去重
      let random = Math.round(Math.random() * 4294967296); //消息随机数，用于去重
      let msgTime = Math.round(new Date().getTime() / 1000); //消息时间戳
      let subType = this.webim.C2C_MSG_SUB_TYPE.COMMON; //消息子类型 webim.C2C_MSG_SUB_TYPE
      let msg = new this.webim.Msg(
        this.selSess, //session 消息所属的会话(e.g：我与好友 A 的 C2C 会话，我与群组 G 的 GROUP 会话)
        true, //消息是否为自己发送标志
        seq, //消息序列号，用于消息判重
        random, //消息随机数，用于消息判重
        msgTime, //消息时间戳，UNIX timestamp格式
        this.loginInfo.identifier, //消息发送者帐号
        subType, //消息子类型 C2C 消息时，参考 C2C 消息子类型对象：webim.C2C_MSG_SUB_TYPE 群消息时，参考群消息子类型对象：webim.GROUP_MSG_SUB_TYPE
        this.loginInfo.identifierNick //消息发送者昵称，用户没有设置昵称时，则为发送者帐号
      );
      console.log(this.selSess);

      //解析文本和表情
      let expr = /\[[^[\]]{1,3}\]/gm; //判断表情 [表情]
      let emotions = msgContent.match(expr);
      let text_obj, face_obj, tmsg, emotionIndex, emotion, restMsgIndex;
      if (!emotions || emotions.length < 1) {
        // 不包含表情
        text_obj = new this.webim.Msg.Elem.Text(msgContent);
        msg.addText(text_obj);
      } else {
        // 有表情
        // 官方的解析文本与表情
        for (var i = 0; i < emotions.length; i++) {
          tmsg = msgContent.substring(0, msgContent.indexOf(emotions[i]));
          if (tmsg) {
            text_obj = new this.webim.Msg.Elem.Text(tmsg);
            msg.addText(text_obj);
          }
          emotionIndex = this.EmotionDataIndexs[emotions[i]]; //表情标识字符串和 index 的 Map  表情标识字符串和 index 的映射关系对象
          emotion = this.Emotions[emotionIndex]; // this.Emotions 表情对象
          if (emotion) {
            face_obj = new this.webim.Msg.Elem.Face(emotionIndex, emotions[i]);
            msg.addFace(face_obj);
          } else {
            text_obj = new this.webim.Msg.Elem.Text(emotions[i]);
            msg.addText(text_obj);
          }
          restMsgIndex = msgContent.indexOf(emotions[i]) + emotions[i].length;
          msgContent = msgContent.substring(restMsgIndex);
        }
        if (msgContent) {
          text_obj = new this.webim.Msg.Elem.Text(msgContent);
          msg.addText(text_obj);
        }
      }
      this.isSend = true;
      // 发送消息
      this.webim.sendMsg(
        msg,
        resp => {
          console.log(resp);
          this.webim.Log.info("发消息成功");
          this.showMes(msg);
          this.textareaCon = "";
          this.isSend = false;

          let ANewImMeg = {
            id: this.selToID,
            isCur: true,  //  是当前对话人员
            msg: msg
          };
          this.$root.Bus.$emit("ANewImMeg", ANewImMeg);
        },
        err => {
          //  todo
          // 后台错误记录
          this.webim.Log.error("发消息失败:" + err.ErrorInfo);
          console.error(err);
          this.isSend = false;
        }
      );
    },
    //  发送图片
    sendPic(images, imgName) {
      if (!this.selSess) {
        this.selSess = new this.webim.Session(
          this.selType,
          this.selToID,
          "",
          "",
          Math.round(new Date().getTime() / 1000)
        );
      }

      let msg = new this.webim.Msg(
        this.selSess,
        true,
        -1,
        -1,
        -1,
        this.loginInfo.identifier,
        0,
        this.loginInfo.identifierNick
      );

      console.debug(imgName.split(".")[1]);
      let images_obj = new this.webim.Msg.Elem.Images(
        images.File_UUID,
        imgName.split(".")[1]
      );
      for (let i in images.URL_INFO) {
        let img = images.URL_INFO[i];
        let newImg;
        let type;
        switch (
          img.PIC_TYPE //	返回的就是三种图源 原图 小图 大图
        ) {
          case 1: //原图
            type = 1; //原图
            break;
          case 2: //小图（缩略图）
            type = 3; //小图
            break;
          case 4: //大图
            type = 2; //大图
            break;
        }
        // webim.IMAGE_TYPE 图片大小类型，取值范围：
        // 1) webim.IMAGE_TYPE.SMALL-小图
        // 2) webim.IMAGE_TYPE.LARGE-大图
        // 3) webim.IMAGE_TYPE.ORIGIN-原图
        newImg = new this.webim.Msg.Elem.Images.Image(
          type, //图片大小类型，详细定义请参考 webim.IMAGE_TYPE
          img.PIC_Size, //图片大小，单位：字节
          img.PIC_Width, //宽度，单位：像素
          img.PIC_Height, //高度，单位：像素
          img.DownUrl //图片地址
        );
        images_obj.addImage(newImg);
      }
      msg.addImage(images_obj);
      //if(imgName){
      //    var data=imgName;//通过自定义消息中的data字段保存图片名称
      //    var custom_obj = new webim.Msg.Elem.Custom(data, '', '');
      //    msg.addCustom(custom_obj);
      //}
      //调用发送图片消息接口
      this.webim.sendMsg(
        msg,
        resp => {
          this.showMes(msg);
          console.log(resp);

          let ANewImMeg = {
            id: this.selToID,
            isCur: true,  //  不是当前对话人员
            msg: msg
          };
          this.$root.Bus.$emit("ANewImMeg", ANewImMeg);
        },
        err => {
          console.log(err);
        }
      );
    },
    //  上传图片
    uploadImage() {
      let file = this.$refs.images.files[0],
        businessType = this.webim.UPLOAD_PIC_BUSSINESS_TYPE.C2C_MSG,
        opt = {
          file: file, //图片对象
          onProgressCallBack: this.onProgressCallBack, //上传图片进度条回调函数
          //'abortButton': document.getElementById('upd_abort'), //停止上传图片按钮
          To_Account: this.selToID, //接收者
          businessType: businessType //业务类型
        };
      // 检测文件格式
      let _arr = file && file.name && file.name.split(".");
      let type = _arr[_arr.length - 1];
      let allowFiles = ["png", "jpg", "jpeg", "bmp"];
      if (allowFiles.indexOf(type.toLowerCase()) < 0) {
        this.$message({
          type: "warning",
          message: this.$t("IM.UnsupportedFileType")
        });
        return;
      }
      //判断文件大小
      if (file.size > 1000 * 2 * 1024) {
        this.$message({
          type: "warning",
          message: this.$t("IM.FileLarge")
        });
        return;
      }

      // 上传图片
      this.webim.uploadPic(
        opt,
        resp => {
          console.log(resp);
          //上传成功发送图片
          this.sendPic(resp, file.name);
        },
        err => {
          console.log(err.ErrorInfo);
        }
      );
    },
    //  显示一条聊天信息
    showMes(msg, isHis) {
      let name = "";
      if (msg.isSend) {
        //  当前用户发送的
        name = "我";
      } else {
        name = msg.fromAccountNick;
        //  todo 头像
      }
      let msgArr = msg.elems,
        msgcon = "",
        time = Number(msg.time + "000") || new Date(),
        type,
        lessonInfo;

      msgArr.forEach(msgElem => {
        type = msgElem.type; //获取元素类型
        let content = msgElem.content; //获取元素对象
        switch (type) {
          case this.webim.MSG_ELEMENT_TYPE.TEXT:
            msgcon += content.text;
            break;
          case this.webim.MSG_ELEMENT_TYPE.FACE:
            msgcon +=
              "<img src='" +
              this.Emotions[content.index][1] +
              "' title='" +
              this.Emotions[content.index][0] +
              "'/>";
            break;
          case this.webim.MSG_ELEMENT_TYPE.IMAGE:
            //todo 大图小图
            let url = content.ImageInfoArray[0].url;
            if (url.indexOf("https") == -1) {
              url = "https" + url.slice(4);
            }
            let tmpimg = new Image();
            tmpimg.src = url;
            tmpimg.onload = () => {
              this.scrollToNew();
            }
            msgcon += "<img src='" + url + "'/>";
            break;
          case this.webim.MSG_ELEMENT_TYPE.CUSTOM:
            if (content.desc == "lessonInfo") {
              let data = JSON.parse(content.data);
              lessonInfo = {};
              lessonInfo.name = data.name;
              lessonInfo.startTime = data.startTime;
              lessonInfo.endTime = data.endTime;
            }
            break;
          default:
            console.warn("未解析消息元素类型: elemType=" + type);
            break;
        }
      });
      //  是否需要显示时间
      let newMsg = {
        time: time,
        name: name,
        isMe: msg.isSend,
        con: msgcon,
        type: type,
        isShowTime: this.isShowTime(time, isHis),
        lessonInfo: lessonInfo
      };
      if (!!isHis) {
        this.chatlist.unshift(newMsg);
      } else {
        this.chatlist.push(newMsg);
      }
      this.scrollToNew();
    },
    imagesUplodReady() {
      return this.$refs.images.click();
    },
    showChatWin(info) {
      let userId = info.id,
        userNick = info.nickName,
        lessonInfo = info.lessonInfo;
      if (!userId) return;
      this.setUnreadListRead(userId);
      if (userId.indexOf("test") > -1 || userId.indexOf("prod") > -1) {
        userId = userId.slice(4);
      }
      this.selToID = `${this.WITSBOX_ENV_PARAM.IMAccountPrefix}${userId}`;
      this.selToNickName = userNick;
      if (!!lessonInfo && !!lessonInfo.name) {
        this.showLessonInfo = true;
        this.lessonInfo.name = info.lessonInfo.name;
        this.lessonInfo.startTime = info.lessonInfo.startTime;
        this.lessonInfo.endTime = info.lessonInfo.endTime;
      }
			console.log("userId",userId)
			  this.request
			    .post(`${this.WITSBOX_ENV_PARAM.baseUrl}/im/getPortrait`, [
			       this.selToID
			    ])
			    .then(res => {
			      if (res.UserProfileItem && res.UserProfileItem.length) {
			        let UserProfileItem = res.UserProfileItem;
			        if (
			          !!UserProfileItem &&
			          UserProfileItem.length &&
			          !!UserProfileItem[0].ProfileItem &&
			          UserProfileItem[0].ProfileItem.length
			        ) {
			          this.selToHeadImg =
			            (UserProfileItem[0].ProfileItem[1] &&
			              UserProfileItem[0].ProfileItem[1].Value) ||
			            "";
								
			        }
			      }
			    });
      this.isShow = true;
      this.getLastC2CHistoryMsgs(this.selToID);
    },
    closeChatWin() {
      this.selToID = "";
      this.selToNickName = "";
      this.selSess = null;
      this.isShow = false;
      this.chatlist = [];
      this.textareaCon = "";

      this.canGetHis = false;
      this.MsgKey = "";
      this.LastMsgTime = 0;
      this.lastChatTime = 0;

      this.showLessonInfo = false;
      this.lessonInfo = {};
    },
    isShowTime(time, isHis) {
      if (!isHis) {
        let isShowTime = time - this.lastChatTime > 600000;
        this.lastChatTime = time;
        return isShowTime;
      } else {
        let isShowTime = this.lastChatTime - time > 600000;
        this.lastChatTime = time;
        return isShowTime;
      }
    },
    dateFormatTime(time) {
      let nowDay = new Date(),
        nowT = new Date(
          nowDay.getFullYear(),
          nowDay.getMonth(),
          nowDay.getDate()
        ),
        msgDay = new Date(time),
        msgT = new Date(
          msgDay.getFullYear(),
          msgDay.getMonth(),
          msgDay.getDate()
        ),
        dayT = parseInt((nowT - msgT) / 1000 / 60 / 60 / 24);
      if (dayT == 0) {
        return this.global.formatDate(time, "H:i");
      } else {
        return this.global.formatDate(time, "yyyy-mm-dd H:i");
      }
    },
    //  获取单个对象历史
    getLastC2CHistoryMsgs(uid) {
      this.webim.getC2CHistoryMsgs(
        {
          Peer_Account: uid, //好友帐号，selToID 为全局变量，表示当前正在进行的聊天 ID，当聊天类型为私聊时，该值为好友帐号，否则为群号。
          MaxCnt: 15, //拉取消息条数
          LastMsgTime: this.LastMsgTime, //最近的消息时间，即从这个时间点向前拉取历史消息
          MsgKey: this.MsgKey
        },
        resp => {
          let complete = resp.Complete; //是否还有历史消息可以拉取，1-表示没有，0-表示有
          // let retMsgCount = resp.MsgCount; //返回的消息条数，小于或等于请求的消息条数，小于的时候，说明没有历史消息可拉取了
          this.canGetHis = !complete;
          this.MsgKey = resp.MsgKey;
          this.LastMsgTime = resp.LastMsgTime;
          if (resp.MsgList.length == 0) {
            this.canGetHis = false;
            this.webim.Log.error(
              "没有历史消息了" + this.LastMsgTime + this.MsgKey
            );
            return;
          }
          console.log(resp);
          this.addHisMsg(resp.MsgList);
        },
        () => {
          this.canGetHis = false;
        }
      );
    },
    // 获取最近联系人 只有页面调用时才获取
    getLastChatMem() {
      let _this = this;
      this.webim.getRecentContactList(
        {},
        function(resp) {
          console.log(resp);
          //业务处理
          _this.lastChatCon = [];
          let tempSess,
            tempSessMap = {}; //临时会话变量
          if (resp.SessionItem && resp.SessionItem.length > 0) {
            for (let i in resp.SessionItem) {
              var item = resp.SessionItem[i]; //  一条消息
              let type = item.Type; //接口返回的会话类型
              let sessType,
                sessionId, // 对话者id
                sessionNick = "", //  对话者昵称
                sessionImage = "", //  对话者头像
                senderId = "", //  发送者id
                senderNick = ""; //  发送者昵称
              if (type == _this.webim.RECENT_CONTACT_TYPE.C2C) {
                //私聊 目前只找磁疗信息
                sessType = _this.webim.SESSION_TYPE.C2C; //设置会话类型
                sessionId = item.To_Account; //会话id，私聊时为好友ID或者系统账号（值为@TIM#SYSTEM，业务可以自己决定是否需要展示），注意：从To_Account获取,

                if (sessionId == "@TIM#SYSTEM") {
                  //先过滤系统消息，，
                  _this.webim.Log.warn(
                    "过滤好友系统消息,sessionId=" + sessionId
                  );
                  continue;
                }
              }

              if (!sessionId) {
                //会话id为空
                _this.webim.Log.warn("会话id为空,sessionId=" + sessionId);
                continue;
              }

              if (sessionId == "@TLS#NOT_FOUND") {
                //会话id不存在，可能是已经被删除了
                _this.webim.Log.warn("会话id不存在,sessionId=" + sessionId);
                continue;
              }

              //  过滤发奖学金的系统用户
              if (_this.webim.Tool.formatText2Html(sessionId) == "deadmin") {
                continue;
              }

              tempSess = tempSessMap[sessType + "_" + sessionId];
              if (!tempSess) {
                //先判断是否存在（用于去重），不存在增加一个
                tempSessMap[sessType + "_" + sessionId] = true;
                _this.lastChatCon.push({
                  SessionType: sessType, //会话类型 永远是c2c
                  SessionId: _this.webim.Tool.formatText2Html(sessionId), //会话id
                  SessionNick: _this.webim.Tool.formatText2Html(sessionNick), //会话昵称
                  SessionImage: sessionImage, //会话头像
                  C2cAccount: _this.webim.Tool.formatText2Html(senderId), //发送者id
                  C2cNick: _this.webim.Tool.formatText2Html(senderNick), //发送者昵称
                  UnreadMsgCount: _this.getUnreadMsgCount(
                    _this.webim.Tool.formatText2Html(sessionId)
                  ), //未读消息数
                  MsgSeq: item.MsgSeq, //消息seq
                  MsgRandom: item.MsgRandom, //消息随机数
                  MsgTimeStamp: _this.webim.Tool.formatTimeStamp(
                    item.MsgTimeStamp
                  ), //消息时间戳
                  MsgShow: item.MsgShow //消息内容
                });
              }
            }
          }
          _this.$root.Bus.$emit("returnLastChatCon", _this.lastChatCon);
        },
        function(resp) {
          //错误回调
        }
      );
    },
    //  获取未读 登陆时
    getUnreadMsg() {
      this.webim.syncMsgs(this.initUnreadMsgCount);
    },
    //  初始化最近会话的消息未读数
    initUnreadMsgCount() {
      let sess;
      let sessMap = this.webim.MsgStore.sessMap();
      console.log(sessMap);
      for (let i in sessMap) {
        sess = sessMap[i];
        // if (selToID && selToID != sess.id()) { //更新其他聊天对象的未读消息数
        console.info("未读消息", sess.id(), sess.unread());
        let unread = {
          uid: sess.id(),
          unreadcount: sess.unread()
        };
        if(sess.id()=="deadmin") {
          this.getCustomMessage(sess.msgs()[0]) ;
            
          // 奖学金IM消息什么都不做 到移动端处理
        } else {
          this.initUnreadList.push(unread);
        }
      }
      if (this.initUnreadList.length && !this.selToID) {
        //  有未读消息且不为空
        // 向上级发消息 闪动
        this.$root.Bus.$emit("newImMeg", true);
      }
    },
    //  查找未读数
    getUnreadMsgCount(uid) {
      if (!this.initUnreadList.length) return 0;
      let obj = this.initUnreadList.find(i => {
        return i.uid == uid;
      });
      if (!!obj) {
        return obj.unreadcount;
      } else {
        return 0;
      }
    },
    //  设置未读列表为已读
    setUnreadListRead(uid) {
      if (!this.initUnreadList.length) return 0;
      let objIndex = this.initUnreadList.findIndex(i => {
        return i.uid == uid;
      });
      if (objIndex > -1) {
        this.initUnreadList[objIndex].unreadcount = 0;
      }
    },
    //  本地未读列表列表 未读数字
    addUnreadListCount(uid) {
      let objIndex = this.initUnreadList.findIndex(i => {
        return i.uid == uid;
      });
      if (objIndex > -1) {
        this.initUnreadList[objIndex].unreadcount++;
      } else {
        let unread = {
          uid: uid,
          unreadcount: 1
        };
        this.initUnreadList.push(unread);
      }
    },
    //  滚动条到最新
    scrollToNew() {
      //  todo  鼠标是否hover
      setTimeout(() => {
        let height = this.$refs.wincon.offsetHeight;
        this.$refs.winconwrap.scrollTop = height;
      }, 50);
    },
    // 插入历史消息
    addHisMsg(mesList) {
      let list = mesList.reverse(),
        selSess;
      list.forEach(mes => {
        this.showMes(mes, true);
        selSess = mes.getSession();
      });
      //  历史消息标记为已读
      this.webim.setAutoRead(selSess, true, true);
    },
    //  关闭消息
    closeLessonInfo() {
      this.showLessonInfo = false;
    },
    //  发送课程消息
    sendLessonInfo() {
      if (this.isSend) return;
      if (!this.lessonInfo || !this.lessonInfo.name) return;
      let info = JSON.stringify(this.lessonInfo);
      this.showLessonInfo = false;

      if (!this.selSess) {
        this.selSess = new this.webim.Session(
          this.selType, //会话类型， 包括群聊和私聊，具体参考 webim. SESSION_TYPE 常量对象，必填
          this.selToID, //对方 ID，群聊时，为群ID；私聊时，对方帐号，必填
          "", //对方名称，群聊时，为群名称；私聊时，为对方昵称，暂未使用，选填
          "", //对方头像 URL，暂未使用，选填
          Math.round(new Date().getTime() / 1000) //当前会话中的最新消息的时间戳，UNIX timestamp 格式，暂未使用，选填
        );
      }

      let seq = -1; //消息序列，-1表示sdk自动生成，用于去重
      let random = Math.round(Math.random() * 4294967296); //消息随机数，用于去重
      let msgTime = Math.round(new Date().getTime() / 1000); //消息时间戳
      let subType = this.webim.C2C_MSG_SUB_TYPE.COMMON; //消息子类型 webim.C2C_MSG_SUB_TYPE
      let msg = new this.webim.Msg(
        this.selSess, //session 消息所属的会话(e.g：我与好友 A 的 C2C 会话，我与群组 G 的 GROUP 会话)
        true, //消息是否为自己发送标志
        seq, //消息序列号，用于消息判重
        random, //消息随机数，用于消息判重
        msgTime, //消息时间戳，UNIX timestamp格式
        this.loginInfo.identifier, //消息发送者帐号
        subType, //消息子类型 C2C 消息时，参考 C2C 消息子类型对象：webim.C2C_MSG_SUB_TYPE 群消息时，参考群消息子类型对象：webim.GROUP_MSG_SUB_TYPE
        this.loginInfo.identifierNick //消息发送者昵称，用户没有设置昵称时，则为发送者帐号
      );

      //消息元素对象（自定义）
      let custom_obj = new this.webim.Msg.Elem.Custom(
        info, //数据
        "lessonInfo", //描述
        "" //扩展字段
      );

      msg.addCustom(custom_obj); //向 Elems 中添加一个 Custom 元素
      // 发送自定义消息
      this.webim.sendMsg(
        msg,
        resp => {
          this.isSend = false;
          this.showMes(msg);
          this.webim.Log.info("发消息成功");
          let ANewImMeg = {
            id: this.selToID,
            isCur: true,  //  不是当前对话人员
            msg: msg
          };
          this.$root.Bus.$emit("ANewImMeg", ANewImMeg);
        },
        err => {
          this.showLessonInfo = true;
          this.isSend = false;
          this.webim.Log.error("发消息失败:" + err.ErrorInfo);
        }
      );
    },
    // 接收奖学金领取消息
    getCustomMessage(msg) {
      let elem = msg && msg.elems && msg.elems[0];
      console.log('消息===》',elem)
      let content = elem.content;
      if(content.desc=="scholarship") {
        // 奖学金IM消息什么都不做 到移动端处理
      } else if(content.desc=="neoFinishPT") {
        // "neoFinishPT" neo完成PT测试 要弹框
        let data = JSON.parse(content.data);
        let message = `<div class="t-left mls"> <div>${this.$t("neo.finishTips2")}</div>`+
        `<div class="mts">${this.$t("neo.userAccount")}${data.email} </div>`+
        `<div>${this.$t("neo.userPwd")}${data.mobilePhone} </div>`+
        `<div class="mts">${this.$t("neo.finishTip3")}</div><div>`;
        //  历史消息标记为已读
        let selSess = msg.getSession();
        this.webim.setAutoRead(selSess, true, true);

        this.$confirm(message, this.$t("neo.finishTips1"), {
          closeOnClickModal: false,
          cancelButtonText: this.$t("common.cancel"),
          confirmButtonText: this.$t("neo.toDownload"),
          confirmButtonClass: 'confirm',
          customClass: 'webstu-msgbox neoPlacement',
          dangerouslyUseHTMLString: true
        }).then(() => {
           this.$store.dispatch("common/changeNeoCodeVisible", true)
        }).catch(() => {
        });

      } else if(content.desc=="exercise") {
        this.goToAnswerExam(msg, content)
      } else if(content.desc=="homework") {
        this.goToAnswerExam(msg, content)
      }else if (content.desc == 'themeLevelScholarship') {
			
				this.themeLevelShow = true;
				// this.enterpriseName = content.data;
        const newData = JSON.parse(content.data)
        if(this.langIsEn == 'en') {
          this.enterpriseName = `Congratulations on completing your study goals and winning ${newData.amount} scholarships`;
        } else {
          this.enterpriseName = `恭喜您完成专题的第 ${newData.step} 阶段学习目标，获得 ${newData.amount} 奖学金`;
        }
				let selSess = msg.getSession();
				this.webim.setAutoRead(selSess, true, true);
			} else if (content.desc == 'upgrade') {
			
				this.upgrade(JSON.parse(content.data))
				let selSess = msg.getSession();
				this.webim.setAutoRead(selSess, true, true);
			}else if (content.desc == 'dayTargetFinished') {
				// 学习目标完成
				this.Toast('恭喜你今日目标已达成！')
				this.finishCompleted()
        let selSess = msg.getSession();
				this.webim.setAutoRead(selSess, true, true);
			}else if (content.desc == 'freeLearningTargetProgressFinish') {
				// 累计x天学习目标完成
				this.targetProgressFinish()
        let selSess = msg.getSession();
				this.webim.setAutoRead(selSess, true, true);
			}

    },
    finishCompleted(){
			// 学习目标完成存储状态
			let time = this.global.formatDate(new Date(),'yyyy-mm-dd')
			let learningCompleted = JSON.parse(localStorage.getItem('learning-completed'))
			let params = {
				time:time,
				isCompleted:true,
				countDay:learningCompleted&&learningCompleted.countDay?learningCompleted.countDay-1:0,
				isShowDay:learningCompleted&&learningCompleted.isShowDay?learningCompleted.isShowDay:false
			}
			localStorage.setItem('learning-completed',JSON.stringify(params))
		},
    targetProgressFinish(){
			this.Dialog.confirm({
				closeOnClickOverlay: true,
				className: 'wis-notitle-dialog',
				message: `恭喜你今日目标已达成！快去app查看你的学习报告吧！`,
				cancelButtonText: this.$t('common.cancel'),
				confirmButtonText: '确认'
			}).then(() => {
				
			}).catch(() => {
			});
		},
		// 天天练升级
		upgrade(item) {
			console.log('upgrade=>', item);
			this.sameGradeUserNum = item.sameGradeUserNum;
			this.grade = item.grade
			this.upgradeShow = true
		
			this.global.updateStorageData(
				'daily-grade-point',
				item.nowPoint + item.givePoint,
				15 * 60 * 1000
			)
			let user = JSON.parse(localStorage.getItem('TTLuserInfo')) || {}
			user.grade = item.grade
			user.upgradeRequirePoint =
				this.WITSBOX_ENV_PARAM.levelOptions[item.grade]
			this.$root.Bus.$emit('upgrade', item.grade)
			localStorage.setItem('TTLuserInfo', JSON.stringify(user))
		},
		closeLevelScholarship() {
			this.themeLevelShow = false
		},
    // 自学任务 作业任务提醒
    goToAnswerExam(msg, content) {
      let data = content.data && JSON.parse(content.data);
      console.log("goToAnswerExam====", data)
      let _data = {};
      _data.lessonNo = data.lessonNo;
      _data.qid = data.qid;
      _data.projectId = data.projectId;
      _data.studentId = data.studentId;
      _data.redirectUrl = `${this.WITSBOX_ENV_PARAM.hostUrl}/study/schedule?projectId=${data.projectId}`;
      _data.updateType = data.updateType;
      _data.typeName = data.typeName||"";
      _data.status = data.status||0;
      _data.courseId = data.courseId;
      _data.homeworkNum = data.homeworkNum;
      _data.bookType = data.bookType;
      _data.teachingMode = data.teachingMode;
      localStorage.setItem("updateStudyProgress", JSON.stringify(_data));
      console.log("_data====", _data)
      // 历史消息标记为已读
      let selSess = msg.getSession();
      this.webim.setAutoRead(selSess, true, true);
      let message=""
      if(data.updateType==3) {
        // 课前预习对于上课非常必要，赶紧完成自学任务吧
        message = this.$t('IM.exerciseTaskTips');
      } else if(data.updateType==5) {
        // 您有一份作业待完成，是否立即完成？
        message = this.$t('IM.homeworkTaskTips');
      }
      this.$confirm(
        `<p>${message}<p>`,
        this.$t("common.titleTips"),
        {
          confirmButtonText: this.$t('IM.doNow'),
          cancelButtonText: this.$t('IM.doLater'),
          cancelButtonClass: "cancel",
          confirmButtonClass: "confirm",
          customClass: "webstu-msgbox",
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
           this.global.winopen(`${this.WITSBOX_ENV_PARAM.examUrl}/answerStartExam.html?paperId=${_data.qid}`+
          `&answerPaperId=&status=0&operation=do`)
          this.$confirm(`<p>${this.$t('schedule.continueStudy')}<p>`, `${this.$t('schedule.taskIsFinished')}`, {
            showClose: false,
            closeOnClickModal: false,
            showCancelButton: false,
            confirmButtonText: `${this.$t('schedule.ikonow')}`,
            confirmButtonClass: 'confirm',
            customClass: 'webstu-msgbox',
            dangerouslyUseHTMLString: true
          }).then(() => {
            window.location.reload()
          })
        })
        .catch(() => {
          let url = `/study/schedule?projectId=${_data.projectId}`;
          window.location.href = `${this.WITSBOX_ENV_PARAM.hostUrl}${url}`;
        });
    },
  }
};
</script>

<style lang="scss">
.imchatWin {
  .bg {
    border-radius: 4px;
    box-shadow: 3px 3px 6px rgba(153, 153, 153, 0.3);
    margin-bottom: 25px;
  }
  p {
    margin: 0;
    padding: 0;
  }
  .mgsbody {
    img {
      max-width: 370px;
      display: block;
    }
  }

	}
</style>


<style lang="scss" scoped>
#imchatWin {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  display: none;
  line-height: 1;
  &.show {
    z-index: 99999;
    display: block;
    .imchatWin {
      top: 50%;
    }
  }
	&.show1{
		 display: block;
	}
	.swiperBj_1 {
		background: linear-gradient(150deg, #95CAFC, #95A642);
	}
	
	.swiperBj_2 {
		background: linear-gradient(150deg, #95CAFC, #71A341);
	}
	
	.swiperBj_3 {
		background: linear-gradient(150deg, #95CAFC, #52A341);
	}
	
	.swiperBj_4 {
		background: linear-gradient(150deg, #95CAFC, #3F9A56);
	}
	
	.swiperBj_5 {
		background: linear-gradient(150deg, #95CAFC, #42A68D);
	}
	
	.swiperBj_6 {
		background: linear-gradient(150deg, #95CAFC, #428FA6);
	}
	
	.swiperBj_7 {
		background: linear-gradient(150deg, #95CAFC, #4168A3);
	}
	
	.swiperBj_8 {
		background: linear-gradient(150deg, #95CAFC, #4043A1);
	}
	
	.swiperBj_9 {
		background: linear-gradient(150deg, #95CAFC, #6041A3);
	}
	
	.swiperBj_10 {
		background: linear-gradient(150deg, #95CAFC, #8240A1);
	}
	
	.swiperBj_11 {
		background: linear-gradient(150deg, #95CAFC, #9E3F95);
	}
	
	.swiperBj_12 {
		background: linear-gradient(150deg, #95CAFC, #9E3F6A);
	}
	
	.swiperBj_13 {
		background: linear-gradient(150deg, #95CAFC, #9E413F);
	}
	
	.swiperBj_14 {
		background: linear-gradient(150deg, #95CAFC, #A16540);
	}
	
	.swiperBj_15 {
		background: linear-gradient(150deg, #95CAFC, #BAA04A);
	}
	.swiperBj_16 {
	  background: linear-gradient(150deg,  #95cafc, #f2a254);
	}
	.swiperBj_17 {
	  background: linear-gradient(150deg,  #95cafc, #ed6463);
	}

	.page-wrap1 {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			text-align: center;
			width: 310px;
			min-height: 200px;
			height: auto;
			border-radius: 12px;
		
		.content-block {
				text-align: center;
				border-radius: 10px;
				padding: 25px 11px 15px 15px;
				margin-bottom: 10px;
			}
		
			.grade {
				width: 91px;
				height: 84px;
			}
		
			.grade_Content {
				text-align: left;
			}
		
			.LG_Equity-t {
				margin-top: 15px;
				text-align: left;
				font-size: 12px;
				font-family: PingFang SC;
				font-weight: 400;
				color: #341D78;
				line-height: 12px;
			}
		
			.LG_Equity {
				width: 100%;
				display: flex;
				justify-content: space-evenly;
				margin: 15px 0 10px;
			}
		
			.LG_Equity_item {
				display: flex;
				flex-direction: column;
				align-items: center;
				font-size: 12px;
				font-family: PingFang SC;
				font-weight: 400;
				color: #341D78;
				line-height: 30px;
			}
		
			.LG_Equity_Img {
				width: 40px;
				height: 40px;
				background: #fff;
				border-radius: 50%;
				margin-bottom: 10px;
			}
		
			.goToGrade {
				text-decoration: underline;
				text-align: right;
			}
		
			.LG_content {
				font-family: PingFang SC;
				font-weight: 400;
				line-height: 10px;
			}
		
			.grade_tip_01 {
				font-size: 24px;
				line-height: 24px;
		
			}
		
			.grade_tip_02 {
				margin: 15px 0 10px 0;
				font-size: 15px;
				line-height: 15px;
		
			}
			.jbzt1 {
				color: #4D3D9F;
		
			}
			.jbzt {
				background:-webkit-linear-gradient(91deg, #4D3D9F 0%, #7171D9 100%);
				background: linear-gradient(91deg, #4D3D9F 0%, #7171D9 100%);
				-webkit-background-clip: text;
				background-clip: text;
				-webkit-text-fill-color: transparent;
				text-fill-color: transparent;
			}
		
			.grade_tip_03 {
				font-size: 10px;
				color: #fff;
			}
		
			.grade-tip1 {
				font-size: 18px;
				line-height: 21px;
				color: #304fad;
			}
		
			.grade-tip2 {
				font-size: 12px;
				line-height: 15px;
				color: #666;
				margin: 8px auto 0;
			}
		}
	
  #mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  .imchatWin {
    width: 540px;
    position: absolute;
    z-index: 1;
    background: #fff;
    border-radius: 3px;
    top: -1000%;
    left: 50%;
    margin-left: -270px;
    margin-top: -280px;
    overflow: hidden;
    transition: top 0.3s;
    .wintitle {
      height: 50px;
      line-height: 50px;
      position: relative;
      color: #fff;
      font-size: 16px;
      text-align: center;
      background: linear-gradient(-234deg, #29418a 0%, #0f2770 100%);
      .el-icon-close {
        font-size: 18px;
        color: #fff;
        position: absolute;
        top: 0;
        right: 15px;
        height: 50px;
        line-height: 50px;
        cursor: pointer;
      }
    }
    .winconwrap {
      height: 400px;
      overflow-y: auto;
      .wincon {
        padding: 5px 8px;
        overflow: hidden;
        .msgtime {
          color: #999;
          font-size: 14px;
          font-weight: bold;
          text-align: center;
          line-height: 40px;
          height: 40px;
          clear: both;
        }
        .lessonmsg {
          padding: 0 15px;
          clear: both;
          position: relative;
          .title {
            font-weight: bold;
            line-height: 22px;
            padding: 6px 0;
            font-size: 18px;
          }
          .time {
            line-height: 25px;
            height: 30px;
            padding-bottom: 5px;
            color: #0f2770;
            font-size: 16px;
          }
          .el-icon-close {
            color: #6e7cab;
            position: absolute;
            top: 7px;
            right: 5px;
            font-size: 20px;
            cursor: pointer;
          }
          .sendLessonInfoBtn {
            position: absolute;
            right: 35px;
            bottom: 10px;
            text-decoration: underline;
            cursor: pointer;
            color: #0f2770;
            font-size: 12px;
          }
        }
        .mgsbody {
          position: relative;
          max-width: 390px;
          padding: 5px 10px;
          font-size: 16px;
          line-height: 40px;
          word-break: break-all;
          text-align: left;
          img {
            max-width: 370px;
            display: block;
          }
          .face {
            width: 50px;
            height: 50px;
            border-radius: 3px;
            overflow: hidden;
            position: absolute;
            top: 0;
            img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          &.other {
            clear: both;
            float: left;
            margin-left: 65px;
            color: #666;
            .face {
              left: -65px;
            }
          }
          &.me {
            float: right;
            clear: both;
            margin-right: 65px;
            color: #fff;
            background: #0f2770;
            .face {
              right: -65px;
            }
          }
        }
        .mgsbody.other + .mgsbody.other {
          margin-top: -10px;
          // .face {
          //   visibility: hidden;
          // }
        }
        .mgsbody.me + .mgsbody.me {
          margin-top: -10px;
          // .face {
          //   visibility: hidden;
          // }
        }
      }
    }
    .repeatwrap {
      padding: 0 8px 10px;
      border-top: 1px solid #dedede;
      .tools {
        // 工具栏
        text-align: left;
        padding: 8px 0;
        & > span {
          width: 20px;
          height: 20px;
          display: inline-block;
          margin-right: 10px;
          &.facebtn {
            background: url(../../assets/images/icons/IMselectface.svg)
              no-repeat center center / 100% 100%;
          }
          &.imgbtn {
            background: url(../../assets/images/icons/IMselectimg.svg) no-repeat
              center center / 100% 100%;
          }
        }
      }
      #repeatcon,
      #repeatcon:focus {
        height: 40px;
        font-size: 16px;
        line-height: 20px;
        color: #333;
        border: none;
        padding: 0;
        margin: 0;
        display: block;
        width: 100%;
        outline: none;
        resize: none;
      }
      .btns {
        text-align: right;
        padding-top: 5px;
        button {
          line-height: 30px;
          height: 30px;
          width: 66px;
          font-size: 14px;
          color: #fff;
          background: #0f2770;
          border-radius: 3px;
          border: none;
          outline: none;
          &[disabled] {
            background: #ccc;
            cursor: not-allowed;
          }
          &.issend {
            font-size: 12px;
          }
        }
      }
    }
    input[type="file"] {
      display: none;
    }
  }
}
	
.page-mask {
	z-index: 10;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	.topContent {
		width: 295px;
		position: absolute;
		top: 50%;
		left: 50%;
		margin: 0 auto;
		text-align: center;
		transform: translate(-50%, -50%);
	}
	
	.sxjContent {
		width: 310px;
		padding-bottom: 17px;
		background: #FFFFFF;
		border-radius: 10px;
	
	}
	
	.sxjContent .themeLevel {
		margin-top: 7.5px;
		width: 280px;
		padding: 0 15px;
	
	}
	
	.sxjContent .enterpriseName {
		padding: 15px 20px 20px 20px;
		text-align: center;
		font-size: 18px;
		color: #333333;
		line-height: 24px;
	}
	
	.sxjContent .text1 {
		// text-align: right;
		padding: 0 20px;
		font-size: 12px;
		color: #666;
	}
	
	.close1 {
		color: #fff;
		margin-top: 30px;
		width: 24px;
		height: 24px;
	}
		.page-wrap {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			background-color: #fff;
			width: 80%;
			min-height: 240px;
			height: auto;
			border-radius: 12px;

			.finish-block {
				position: relative;
				text-align: center;
				padding-top: 10px;

				.f-info {
					color: #000;
					font-size: 16px;
					line-height: 29px;
					font-weight: bold;
				}

				.f-image {
					width: 200x;
					height: 125px;
				}

				.f-close {
					position: absolute;
					top: 2.5px;
					right: 5px;
				}
			}

			.main-btn {
				margin: 10px 0 0;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/common/imChatWin.vue